import React, { useState, useEffect } from "react";
import {  leaf2, mainLeaf } from "../../assets";
import NewsCard from "../../Components/NewsCard";
import { client, urlFor } from "../../client";
import { useNavigate } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";
import { motion } from "framer-motion";

const Blogs = ({ setSingleBlog, setRecentBlog }) => {
  const [blogs, setBlogs] = useState([]);
  const navigation = useNavigate();

  useEffect(() => {
    client.fetch(`*[_type == "blogs"]`).then((res) => setBlogs(res));
  }, []);

  let recentBlog;

  blogs
    .filter((rBlog) => rBlog.recent === true)
    .map((b) => {
      return (recentBlog = b);
    });

  const handleFuc = () => {
    setRecentBlog(recentBlog);

    navigation("/recent-blog");
  };

  return (
    <>
      {blogs && recentBlog ? (
        <motion.div
          whileInView={{ opacity: [0, 1], y: [50, 0] }}
          transition={{ duration: 0.7 }}
          className="blogsPage"
        >
          <div className="gradient"></div>
          <img src={leaf2} className="mainLeaf" alt="" />
          <img src={mainLeaf} className="mainLeaf2" alt="" />
          <div className="title">
            <h1>Our Blogs</h1>
            <p>Get updated with our recent blogs</p>
          </div>

          <div className="blogs">
            <div className="recentBlog" onClick={() => handleFuc()}>
              <div className="left">
                <img src={urlFor(recentBlog.blogimg)} alt="" />
              </div>
              <div className="right">
                <small>Recent Blog</small>
                <h1>{recentBlog.title}</h1>
                <p>{recentBlog.shortDesc}</p>
              </div>
            </div>

            <div className="allBlogs">
              {blogs
                .filter((b) => b.recent === false)
                .map((blog, i) => {
                  return (
                    <NewsCard
                      key={i}
                      blog={blog}
                      setSingleBlog={setSingleBlog}
                    />
                  );
                })}
            </div>
          </div>
        </motion.div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Blogs;
